/**
 * 描述列表
 */
import classNames from 'classnames';
import React from 'react';
import toArray from '../_util/childrenToArray';
import { pickDomAttrs } from '../_util/utils';
import Space from '../space';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Descriptions = _ref => {
  let {
    title,
    subtitle,
    actions,
    column = 3,
    rowGap = 16,
    columnGap = 16,
    children,
    justifyItems,
    width,
    height,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = _ref;
  const baseClassName = "".concat(prefixClass, "-descriptions");
  const contentStyle = {
    gridTemplateColumns: "repeat(".concat(column, ", 1fr)"),
    justifyItems: justifyItems,
    gridGap: "".concat(rowGap, "px ").concat(columnGap, "px")
  };
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: {
      ...style,
      width,
      height
    },
    children: [(!!title || !!actions) && /*#__PURE__*/_jsxs("div", {
      className: classNames("".concat(baseClassName, "-title"), {
        hasSubtitle: !!subtitle
      }),
      children: [!!title && /*#__PURE__*/_jsx("div", {
        style: {
          flex: 1
        },
        children: title
      }), !!actions && /*#__PURE__*/_jsx(Space, {
        size: "ll",
        className: "actions",
        children: actions === null || actions === void 0 ? void 0 : actions.map((action, index) => action && /*#__PURE__*/React.cloneElement(action, {
          key: index
        }))
      })]
    }), !!subtitle && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-subtitle"),
      children: subtitle
    }), !!children && /*#__PURE__*/_jsx("div", {
      style: contentStyle,
      className: "".concat(baseClassName, "-content"),
      children: children
    })]
  });
};
const Item = _ref2 => {
  let {
    label,
    columnSpan = 1,
    rowSpan = 1,
    children,
    justifySelf,
    direction = 'vertical',
    width,
    height,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = _ref2;
  const baseClassName = "".concat(prefixClass, "-descriptions-item");
  const attrs = pickDomAttrs(restProps);
  const ItemStyle = {
    gridColumnStart: "span ".concat(columnSpan),
    gridRowStart: "span ".concat(rowSpan),
    justifySelf: justifySelf,
    width: width,
    height: height,
    ...style
  };
  return /*#__PURE__*/_jsxs(Space, {
    ...attrs.data,
    style: ItemStyle,
    className: classNames(baseClassName, className),
    direction: direction,
    size: 4,
    children: [label !== undefined && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-label"),
      children: label
    }), children !== undefined && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-text"),
      children: children
    })]
  });
};
const Group = _ref3 => {
  let {
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    isEmptyShow
  } = _ref3;
  const baseClassName = "".concat(prefixClass, "-descriptions-group");
  const items = toArray(children, isEmptyShow);
  const len = items.length;
  if (len === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: classNames(baseClassName, className),
    style: style,
    children: items.map((c, i) => {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [i > 0 && /*#__PURE__*/_jsx("div", {
          className: "".concat(baseClassName, "-divider")
        }), c]
      }, c.key || i);
    })
  });
};
Descriptions.Group = Group;
Descriptions.Item = Item;
export default Descriptions;